(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[951,1829,267,52],[383,1829,289,52],[1575,1829,125,52],[1220,1829,177,52],[1399,1829,174,52],[674,1829,275,52],[0,1829,381,52],[1702,1829,125,52],[0,0,1848,1827]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_8 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_7 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_6 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_5 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_4 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_3 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_2 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib._08 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.zoom_white = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_white, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.zoom_brack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#CBBC97").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#CBBC97").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#CBBC97").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_brack, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape.setTransform(960,540.0009,1,1.08);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#45352D").setStrokeStyle(2,2,0,3).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#CAAF6F").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#45352D").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#CAAF6F").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,2).lineTo(-680,-2).lineTo(680,-2).lineTo(680,2).closePath();
	this.shape.setTransform(680,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1360,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#666666").setStrokeStyle(2,1,1).moveTo(50,-27.5).lineTo(-550,-27.5).moveTo(550,27.5).lineTo(-250,27.5);
	this.shape.setTransform(550,27.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,57), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#B4B0BF").beginStroke().moveTo(27.8,16.9).curveTo(26.6,16.9,25.2,16.5).curveTo(23.8,16,22.6,15.1).curveTo(21.5,14.2,20.6,12.6).curveTo(19.9,11.1,19.8,8.9).lineTo(19.8,-16.9).lineTo(25.6,-16.9).lineTo(25.6,8.9).curveTo(25.5,10,26.2,10.5).curveTo(26.9,11.2,27.8,11.2).lineTo(30.4,11.2).lineTo(30.4,16.9).closePath().moveTo(13.8,16.9).curveTo(12.6,16.9,11.2,16.5).curveTo(9.8,16,8.6,15.1).curveTo(7.3,14.2,6.6,12.6).curveTo(5.8,11.1,5.8,8.9).lineTo(5.8,-16.9).lineTo(11.4,-16.9).lineTo(11.4,8.9).curveTo(11.5,10,12.1,10.5).curveTo(12.8,11.2,13.8,11.2).lineTo(16.3,11.2).lineTo(16.3,16.9).closePath().moveTo(-4,16.9).lineTo(-14.8,-6.6).lineTo(-14.9,-6.7).lineTo(-14.9,-6.6).lineTo(-23.1,11.2).lineTo(-15.5,11.2).lineTo(-12.9,16.9).lineTo(-27.6,16.9).curveTo(-28.8,16.9,-29.6,16).curveTo(-30.4,15.3,-30.4,14).curveTo(-30.4,13.6,-30.2,13.2).lineTo(-22.4,-4.1).lineTo(-22.3,-4.2).lineTo(-22.2,-4.4).lineTo(-20.7,-7.7).lineTo(-16.9,-15.9).lineTo(-16.6,-16.3).curveTo(-16,-16.8,-15,-16.9).lineTo(-14.8,-16.9).curveTo(-13.8,-16.8,-13.2,-16.3).lineTo(-12.8,-15.7).lineTo(-9.1,-7.7).lineTo(-7.6,-4.4).lineTo(-7.5,-4.3).lineTo(-7.5,-4.1).lineTo(0.9,14).lineTo(1,14.2).lineTo(1.3,14.7).lineTo(1.5,15.3).lineTo(2.3,16.9).closePath();
	this.shape.setTransform(97.1163,37.3007,0.7275,0.7273);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#9881D1").beginStroke().moveTo(11.6,20.6).lineTo(11.6,-2.6).curveTo(11.6,-4.1,12,-5.2).curveTo(12.3,-6.4,13,-7.3).curveTo(13.6,-8.2,14.4,-8.8).curveTo(15.2,-9.4,16.2,-9.8).curveTo(17,-10.2,18,-10.4).curveTo(18.8,-10.6,19.6,-10.6).lineTo(29.9,-10.6).curveTo(31.4,-10.6,32.6,-10.2).curveTo(33.7,-9.8,34.6,-9.2).curveTo(35.5,-8.6,36.2,-7.8).curveTo(36.8,-7,37.2,-6.1).curveTo(37.5,-5.2,37.8,-4.3).lineTo(37.9,-2.6).lineTo(37.9,5.2).curveTo(37.9,6.6,37.5,7.8).curveTo(37.2,9,36.5,9.9).curveTo(35.9,10.8,35.2,11.4).curveTo(34.3,12,33.5,12.4).curveTo(32.5,12.8,31.7,13).curveTo(30.7,13.2,29.9,13.2).lineTo(19.6,13.2).lineTo(19.6,7.5).lineTo(29.9,7.5).curveTo(31,7.5,31.7,6.9).curveTo(32.2,6.3,32.2,5.2).lineTo(32.2,-2.5).curveTo(32.2,-3.7,31.7,-4.3).curveTo(31,-4.9,29.9,-4.9).lineTo(19.6,-4.9).curveTo(18.5,-4.9,17.9,-4.3).curveTo(17.3,-3.7,17.3,-2.6).lineTo(17.3,20.6).closePath().moveTo(-11.3,13.2).curveTo(-12.5,13.2,-13.9,12.8).curveTo(-15.2,12.3,-16.4,11.4).curveTo(-17.6,10.5,-18.4,9).curveTo(-19.2,7.5,-19.2,5.3).curveTo(-19.2,4.1,-18.7,2.7).curveTo(-18.4,1.4,-17.4,0.2).curveTo(-16.5,-1,-15,-1.8).curveTo(-13.5,-2.6,-11.3,-2.6).lineTo(-1,-2.6).lineTo(-1,2.9).lineTo(-11.3,2.9).curveTo(-12.5,2.9,-13.1,3.6).curveTo(-13.8,4.3,-13.8,5.4).curveTo(-13.8,6.5,-13,7.1).curveTo(-12.3,7.7,-11.3,7.7).lineTo(-1,7.7).curveTo(0.2,7.7,0.8,7).curveTo(1.4,6.3,1.4,5.3).lineTo(1.4,-2.7).curveTo(1.4,-3.8,0.7,-4.5).curveTo(0.1,-5.2,-1,-5.2).lineTo(-13.5,-5.2).lineTo(-13.5,-10.6).lineTo(-1,-10.6).curveTo(0.1,-10.6,1.5,-10.2).curveTo(2.9,-9.7,4.1,-8.8).curveTo(5.3,-7.9,6,-6.4).curveTo(6.9,-4.9,6.8,-2.7).lineTo(6.8,5.3).curveTo(6.8,6.5,6.5,7.9).curveTo(6,9.2,5.1,10.4).curveTo(4.2,11.6,2.7,12.4).curveTo(1.1,13.2,-1,13.2).closePath().moveTo(-27.2,13.2).curveTo(-28.4,13.2,-29.8,12.8).curveTo(-31.2,12.3,-32.4,11.4).curveTo(-33.6,10.4,-34.4,8.9).curveTo(-35.2,7.4,-35.2,5.2).lineTo(-35.2,-5.2).lineTo(-37.9,-5.2).lineTo(-37.9,-10.6).lineTo(-35.2,-10.6).lineTo(-35.2,-20.6).lineTo(-29.5,-20.6).lineTo(-29.5,-10.6).lineTo(-17.5,-10.6).lineTo(-17.5,-5.2).lineTo(-29.5,-5.2).lineTo(-29.5,5.2).curveTo(-29.5,6.2,-28.8,6.8).curveTo(-28.2,7.5,-27.2,7.5).lineTo(-24.7,7.5).lineTo(-24.7,13.2).closePath();
	this.shape_1.setTransform(147.4235,40.0098,0.7275,0.7273);

	this.instance = new lib._08();
	this.instance.setTransform(94.65,10,0.0328,0.0328);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1,p:{scaleX:0.7275,scaleY:0.7273,x:147.4235,y:40.0098}},{t:this.shape,p:{scaleX:0.7275,scaleY:0.7273,x:97.1163,y:37.3007}}]},2).to({state:[{t:this.shape_1,p:{scaleX:0.9698,scaleY:0.9697,x:154.8939,y:39.9801}},{t:this.shape,p:{scaleX:0.9698,scaleY:0.9697,x:87.832,y:36.368}}]},1).to({state:[{t:this.instance}]},1).wait(1));

	// size
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-125,40).lineTo(-125,-40).lineTo(125,-40).lineTo(125,40).closePath();
	this.shape_2.setTransform(125,40);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,250,80);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_1, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.Path_46 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_46, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_45 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_45, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_44 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_44, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_43 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_43, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_42 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_42, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_41 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_41, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_40 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_40, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_39 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_39, new cjs.Rectangle(0,0,160.2,155), null);


(lib.Path_38 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_38, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_37 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_37, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_36 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_36, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_35 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_35, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_34 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_34, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_33 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_33, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_32 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_32, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_31 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_31, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_30 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_30, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_29 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_29, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_28 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_28, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_27 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_27, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_26 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_26, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_25 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_25, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_24 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_24, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_23 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_23, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_22 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_22, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_21 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_21, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_20 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_20, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_19 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_19, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_18 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_18, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_17 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_17, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_16 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_16, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_15 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_15, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_14 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_14, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_13 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_13, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_12 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_12, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_11, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_10 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_10, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_9, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_8, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_7, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_6, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_5, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_4, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_3, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_2, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_1, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path_0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.1,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path_0, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.Path = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FEFEFE").beginStroke().moveTo(-80.1,77.5).lineTo(-80.1,-77.5).lineTo(80.1,-77.5).lineTo(80.1,77.5).closePath();
	this.shape.setTransform(80.075,77.525);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Path, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_94 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_94, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_92 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_92, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_90, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_88 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_88, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_86 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_86, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_84 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_84, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_82 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_82, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_80 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_80, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_78 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_78, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_76 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_76, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_74 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_74, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_72 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_72, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_70 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_70, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_68 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_68, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_66 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_66, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_64 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_64, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_62 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_62, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_60 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_60, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_58 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_58, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_56 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_56, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_54 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_54, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_52 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_52, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_50 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_50, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_48 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_48, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_46 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_46, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_44 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_44, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_42 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_42, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_40 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_40, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_38 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_38, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_36 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_36, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_34 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_34, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_32 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_32, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_30 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_30, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_28 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_28, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_26 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.9,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_26, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_24 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_24, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_22 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_22, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_20 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.8,-57.2,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_20, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_18 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.8,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_18, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_16 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_16, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_14 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.3,-39.2,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,53.9,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.2).closePath();
	mask.setTransform(80.0996,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_14, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_12 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).lineTo(56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.7,9.5,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.1003,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_12, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_10 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.2).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.9,-57.1,64.4,-49.1).curveTo(73,-38.4,77.1,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.1,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.2).closePath();
	mask.setTransform(80.0761,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_10, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.1,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.0746,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_8, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,53.9,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.7,9.5,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.1003,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_6, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.2).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.8,-57.2,64.4,-49.1).curveTo(73,-38.4,77.1,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).lineTo(56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,0,77.5).curveTo(-12.9,77.5,-25.5,73.2).closePath();
	mask.setTransform(80.0761,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_4, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.8,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.1,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.0746,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_2, new cjs.Rectangle(0,0,0,0), null);


(lib.ClipGroup_0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,53.9,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.1003,77.5112);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_0, new cjs.Rectangle(0,0,0,0), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1197.95,12.4);

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1053.55,12.4);

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(910.05,12.4);

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(671.55,12.4);

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(472.25,12.4);

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(285.85,12.4);

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(89.05,12.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_7 = new lib.square();
	this.instance_7.setTransform(1215.7,13);
	this.instance_7.visible = false;

	this.instance_8 = new lib.square();
	this.instance_8.setTransform(1071.5,13);
	this.instance_8.visible = false;

	this.instance_9 = new lib.square();
	this.instance_9.setTransform(833.4,13);
	this.instance_9.visible = false;

	this.instance_10 = new lib.square();
	this.instance_10.setTransform(1410.4,13);
	this.instance_10.visible = false;

	this.instance_11 = new lib.square();
	this.instance_11.setTransform(634.5,13);
	this.instance_11.visible = false;

	this.instance_12 = new lib.square();
	this.instance_12.setTransform(450.8,13);
	this.instance_12.visible = false;

	this.instance_13 = new lib.square();
	this.instance_13.setTransform(273.8,13);
	this.instance_13.visible = false;

	this.instance_14 = new lib.square();
	this.instance_14.setTransform(88,13);
	this.instance_14.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7}]}).wait(1));

	// ball
	this.instance_15 = new lib.ball();
	this.instance_15.setTransform(1417.4,13);
	this.instance_15.visible = false;

	this.instance_16 = new lib.ball();
	this.instance_16.setTransform(1242.8,13);
	this.instance_16.visible = false;

	this.instance_17 = new lib.ball();
	this.instance_17.setTransform(1116.4,13);
	this.instance_17.visible = false;

	this.instance_18 = new lib.ball();
	this.instance_18.setTransform(934.1,13);
	this.instance_18.visible = false;

	this.instance_19 = new lib.ball();
	this.instance_19.setTransform(773.7,13);
	this.instance_19.visible = false;

	this.instance_20 = new lib.ball();
	this.instance_20.setTransform(606.6,13);
	this.instance_20.visible = false;

	this.instance_21 = new lib.ball();
	this.instance_21.setTransform(428.5,13);
	this.instance_21.visible = false;

	this.instance_22 = new lib.ball();
	this.instance_22.setTransform(259.3,13);
	this.instance_22.visible = false;

	this.instance_23 = new lib.ball();
	this.instance_23.setTransform(79.7,13);
	this.instance_23.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15}]}).wait(1));

	// title
	this.instance_24 = new lib.CachedBmp_8();
	this.instance_24.setTransform(312.4,0,0.5,0.5);

	this.instance_25 = new lib.CachedBmp_7();
	this.instance_25.setTransform(115.3,0,0.5,0.5);

	this.instance_26 = new lib.CachedBmp_6();
	this.instance_26.setTransform(1231.35,0,0.5,0.5);

	this.instance_27 = new lib.CachedBmp_5();
	this.instance_27.setTransform(1081.5,0,0.5,0.5);

	this.instance_28 = new lib.CachedBmp_4();
	this.instance_28.setTransform(938.35,0,0.5,0.5);

	this.instance_29 = new lib.CachedBmp_3();
	this.instance_29.setTransform(503.15,0,0.5,0.5);

	this.instance_30 = new lib.CachedBmp_2();
	this.instance_30.setTransform(695.65,0,0.5,0.5);

	this.instance_31 = new lib.CachedBmp_1();
	this.instance_31.setTransform(-2.15,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(-2.1,0,1423.5,26), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(2).to({y:0},8).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.setTransform(560,2);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#CBBC97").beginStroke().moveTo(-960,27.5).lineTo(-960,-27.5).lineTo(960,-27.5).lineTo(960,27.5).closePath();
	this.shape.setTransform(960,27.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,58), null);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":10,"end":19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart(library_name, 'before');
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete(library_name, 'before');
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd(library_name, 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// logo
	this.instance = new lib.logo_1();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},8).wait(2).to({alpha:0},8).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.ClipGroup_95 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	// Camada_3
	this.instance = new lib.Path();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_95, new cjs.Rectangle(0.1,0,160.1,155.1), null);


(lib.ClipGroup_93 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_0();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_93, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_91 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_1();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_91, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_89 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_2();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_89, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_87 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_3();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_87, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_85 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_4();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_85, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_83 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_5();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_83, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_81 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_6();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_81, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_79 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	// Camada_3
	this.instance = new lib.Path_7();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_79, new cjs.Rectangle(0.1,0,160.1,155.1), null);


(lib.ClipGroup_77 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_8();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_77, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_75 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_9();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_75, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_73 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_10();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_73, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_71 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_11();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_71, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_69 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.7,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_12();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_69, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_67 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_13();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_67, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_65 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_14();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_65, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_63 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	// Camada_3
	this.instance = new lib.Path_15();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_63, new cjs.Rectangle(0.1,0,160.1,155.1), null);


(lib.ClipGroup_61 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_16();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_61, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_59 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_17();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_59, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_57 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_18();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_57, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_55 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_19();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_55, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_53 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_20();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_53, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_51 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_21();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_51, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_49 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_22();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_49, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_47 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	// Camada_3
	this.instance = new lib.Path_23();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_47, new cjs.Rectangle(0.1,0,160.1,155.1), null);


(lib.ClipGroup_45 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_24();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_45, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_43 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58.1,-57,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_25();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_43, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_41 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_26();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_41, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_39 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_27();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_39, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_37 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_28();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_37, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_35 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.7,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58.2,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_29();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_35, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_33 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.2,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58.1,-56.9,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_30();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_33, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_31 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.2,-39.4,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0996,77.5362);

	// Camada_3
	this.instance = new lib.Path_31();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_31, new cjs.Rectangle(0.1,0,160.1,155.1), null);


(lib.ClipGroup_29 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_32();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_29, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_27 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.9,-57.1,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,63,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_33();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_27, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_25 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_34();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_25, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_23 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.8,9.5,77).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_35();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_23, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_21 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.3).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.8,-57.2,64.4,-49.1).curveTo(73,-38.3,77.1,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.2,56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.3).closePath();
	mask.setTransform(80.0761,77.5362);

	// Camada_3
	this.instance = new lib.Path_36();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_21, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_19 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.8,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(25,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.7,53.2,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.0746,77.5362);

	// Camada_3
	this.instance = new lib.Path_37();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_19, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_17 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.3).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.2,-39.4,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.3).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.3,77,-23.9).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,54,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.8,9.6,77).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.3).closePath();
	mask.setTransform(80.1003,77.5362);

	// Camada_3
	this.instance = new lib.Path_38();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_17, new cjs.Rectangle(0,0,160.2,155.1), null);


(lib.ClipGroup_15 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,8.9,-79.9,-6.7).curveTo(-78.9,-21.8,-72.6,-36.1).curveTo(-71.3,-39.2,-68.5,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-67.9,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.8,4.7,-50.9,5.5).curveTo(-48.4,7.4,-47.7,5.3).curveTo(-47.5,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.2,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,45.9,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,53.9,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.2).closePath();
	mask.setTransform(80.0996,77.5112);

	// Camada_3
	this.instance = new lib.Path_39();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_15, new cjs.Rectangle(0.1,0,160.1,155), null);


(lib.ClipGroup_13 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.4,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).lineTo(56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.7,9.5,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.1003,77.5112);

	// Camada_3
	this.instance = new lib.Path_40();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_13, new cjs.Rectangle(0,0,160.2,155), null);


(lib.ClipGroup_11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.2).curveTo(-42.7,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.9,-57.1,64.4,-49.1).curveTo(73,-38.4,77.1,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.1,56.8,54).lineTo(55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.5,73.2).closePath();
	mask.setTransform(80.0761,77.5112);

	// Camada_3
	this.instance = new lib.Path_41();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_11, new cjs.Rectangle(0,0,160.2,155), null);


(lib.ClipGroup_9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.1,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.0746,77.5112);

	// Camada_3
	this.instance = new lib.Path_42();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_9, new cjs.Rectangle(0,0,160.2,155), null);


(lib.ClipGroup_7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.9,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54.1,2.2).curveTo(-48.9,8.5,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,53.9,55.7,55.1).curveTo(54.7,56.3,50.3,59.8).curveTo(46.3,62.9,44.4,64.2).curveTo(28.2,74.7,9.5,76.9).curveTo(4.7,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.1003,77.5112);

	// Camada_3
	this.instance = new lib.Path_43();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_7, new cjs.Rectangle(0,0,160.2,155), null);


(lib.ClipGroup_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.5,73.2).curveTo(-42.7,67.4,-55.7,54.7).curveTo(-69.3,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.8,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.3,-5.2,-54,2.2).curveTo(-48.8,8.5,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.2,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.2,-68,46,-66.1).curveTo(48.3,-64.6,52.8,-61.1).curveTo(57.8,-57.2,64.4,-49.1).curveTo(73,-38.4,77.1,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.7,28.6,62.7,47.4).lineTo(58.6,52.1).lineTo(56.8,54).lineTo(55.8,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.9,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,0,77.5).curveTo(-12.9,77.5,-25.5,73.2).closePath();
	mask.setTransform(80.0761,77.5112);

	// Camada_3
	this.instance = new lib.Path_44();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_5, new cjs.Rectangle(0,0,160.2,155), null);


(lib.ClipGroup_3_0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.8,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-80.9,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.1,-47).curveTo(-66.2,-43.4,-66.6,-41.6).curveTo(-67.7,-35.8,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.8,-15.8,-63.7,-11.8).curveTo(-60.1,-4.9,-54,2.2).curveTo(-52.1,4.6,-50.9,5.5).curveTo(-48.5,7.4,-47.7,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.4,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29,-64.4,-18.3,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.7,52.8,-61.1).curveTo(58,-57,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57.8,53.1,56.8,54).lineTo(55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,-0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.0746,77.5112);

	// Camada_3
	this.instance = new lib.Path_45();
	this.instance.setTransform(80,77.5,1,1,0,0,0,80,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_3_0, new cjs.Rectangle(0,0,160.2,155), null);


(lib.ClipGroup_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-25.6,73.2).curveTo(-42.8,67.4,-55.7,54.7).curveTo(-69.4,41.5,-75.9,23).curveTo(-81,9,-79.9,-6.7).curveTo(-79,-21.8,-72.7,-36.1).curveTo(-71.3,-39.2,-68.6,-43.8).lineTo(-64,-50.8).lineTo(-65.2,-47).curveTo(-66.2,-43.5,-66.6,-41.6).curveTo(-67.7,-36.3,-67.9,-31.1).curveTo(-68,-25.9,-66.8,-20.7).curveTo(-65.7,-15.8,-63.7,-11.8).curveTo(-60.2,-5,-54.1,2.2).curveTo(-51.9,4.7,-51,5.5).curveTo(-48.5,7.4,-47.8,5.3).curveTo(-47.6,4.8,-47.7,-1.5).curveTo(-47.9,-9.3,-47.5,-15.6).curveTo(-45.8,-37.7,-36.1,-53.2).curveTo(-29.1,-64.3,-18.4,-70.6).curveTo(-6.2,-77.7,9.6,-77.5).curveTo(24.9,-77.3,38.5,-70.4).curveTo(43.1,-68,46,-66.1).curveTo(48.2,-64.6,52.7,-61.1).curveTo(58,-57.1,64.4,-49.1).curveTo(73,-38.4,77,-24).curveTo(81.1,-9.6,79.8,5.3).curveTo(77.8,28.5,62.7,47.4).lineTo(58.6,52.1).curveTo(57,53.9,55.7,55.1).curveTo(54.8,56.3,50.3,59.8).curveTo(46.4,62.8,44.4,64.2).curveTo(28.3,74.7,9.6,76.9).curveTo(4.8,77.5,0,77.5).curveTo(-13,77.5,-25.6,73.2).closePath();
	mask.setTransform(80.1003,77.5112);

	// Camada_3
	this.instance = new lib.Path_46();
	this.instance.setTransform(80.1,77.5,1,1,0,0,0,80.1,77.5);
	this.instance.alpha = 0.3203;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_1, new cjs.Rectangle(0,0,160.2,155), null);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(48.9,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:207.25},0).wait(1).to({x:398.85},0).wait(1).to({x:591.7},0).wait(1).to({x:810.6},0).wait(1).to({x:1001.6},0).wait(1).to({x:1145.55},0).wait(1).to({x:1282.35},0).wait(1).to({x:1299.9},0).wait(1).to({x:1454.6},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1477.2,90);


(lib.ClipGroup_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-595.2,420.9).lineTo(-595.2,-420.9).lineTo(595.2,-420.9).lineTo(595.2,420.9).closePath();
	mask.setTransform(640.75,484.625);

	// Camada_3
	this.instance = new lib.ClipGroup_0();
	this.instance.setTransform(1201.35,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_1 = new lib.ClipGroup_1();
	this.instance_1.setTransform(1201.35,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_2 = new lib.ClipGroup_2();
	this.instance_2.setTransform(1041.1,852.75,1,1,0,0,0,80,77.5);

	this.instance_3 = new lib.ClipGroup_3_0();
	this.instance_3.setTransform(1041.1,852.75,1,1,0,0,0,80,77.5);

	this.instance_4 = new lib.ClipGroup_4();
	this.instance_4.setTransform(880.9,852.75,1,1,0,0,0,80,77.5);

	this.instance_5 = new lib.ClipGroup_5();
	this.instance_5.setTransform(881,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_6 = new lib.ClipGroup_6();
	this.instance_6.setTransform(720.8,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_7 = new lib.ClipGroup_7();
	this.instance_7.setTransform(720.8,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_8 = new lib.ClipGroup_8();
	this.instance_8.setTransform(560.55,852.75,1,1,0,0,0,80,77.5);

	this.instance_9 = new lib.ClipGroup_9();
	this.instance_9.setTransform(560.55,852.75,1,1,0,0,0,80,77.5);

	this.instance_10 = new lib.ClipGroup_10();
	this.instance_10.setTransform(400.35,852.75,1,1,0,0,0,80,77.5);

	this.instance_11 = new lib.ClipGroup_11();
	this.instance_11.setTransform(400.45,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_12 = new lib.ClipGroup_12();
	this.instance_12.setTransform(240.25,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_13 = new lib.ClipGroup_13();
	this.instance_13.setTransform(240.25,852.75,1,1,0,0,0,80.1,77.5);

	this.instance_14 = new lib.ClipGroup_14();
	this.instance_14.setTransform(80,852.75,1,1,0,0,0,80,77.5);

	this.instance_15 = new lib.ClipGroup_15();
	this.instance_15.setTransform(80,852.75,1,1,0,0,0,80,77.5);

	this.instance_16 = new lib.ClipGroup_16();
	this.instance_16.setTransform(1201.35,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_17 = new lib.ClipGroup_17();
	this.instance_17.setTransform(1201.35,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_18 = new lib.ClipGroup_18();
	this.instance_18.setTransform(1041.1,697.7,1,1,0,0,0,80,77.5);

	this.instance_19 = new lib.ClipGroup_19();
	this.instance_19.setTransform(1041.1,697.7,1,1,0,0,0,80,77.5);

	this.instance_20 = new lib.ClipGroup_20();
	this.instance_20.setTransform(880.9,697.7,1,1,0,0,0,80,77.5);

	this.instance_21 = new lib.ClipGroup_21();
	this.instance_21.setTransform(881,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_22 = new lib.ClipGroup_22();
	this.instance_22.setTransform(720.8,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_23 = new lib.ClipGroup_23();
	this.instance_23.setTransform(720.8,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_24 = new lib.ClipGroup_24();
	this.instance_24.setTransform(560.55,697.7,1,1,0,0,0,80,77.5);

	this.instance_25 = new lib.ClipGroup_25();
	this.instance_25.setTransform(560.55,697.7,1,1,0,0,0,80,77.5);

	this.instance_26 = new lib.ClipGroup_26();
	this.instance_26.setTransform(400.35,697.7,1,1,0,0,0,80,77.5);

	this.instance_27 = new lib.ClipGroup_27();
	this.instance_27.setTransform(400.45,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_28 = new lib.ClipGroup_28();
	this.instance_28.setTransform(240.25,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_29 = new lib.ClipGroup_29();
	this.instance_29.setTransform(240.25,697.7,1,1,0,0,0,80.1,77.5);

	this.instance_30 = new lib.ClipGroup_30();
	this.instance_30.setTransform(80,697.7,1,1,0,0,0,80,77.5);

	this.instance_31 = new lib.ClipGroup_31();
	this.instance_31.setTransform(80,697.7,1,1,0,0,0,80,77.5);

	this.instance_32 = new lib.ClipGroup_32();
	this.instance_32.setTransform(1201.35,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_33 = new lib.ClipGroup_33();
	this.instance_33.setTransform(1201.35,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_34 = new lib.ClipGroup_34();
	this.instance_34.setTransform(1041.1,542.65,1,1,0,0,0,80,77.5);

	this.instance_35 = new lib.ClipGroup_35();
	this.instance_35.setTransform(1041.1,542.65,1,1,0,0,0,80,77.5);

	this.instance_36 = new lib.ClipGroup_36();
	this.instance_36.setTransform(880.9,542.65,1,1,0,0,0,80,77.5);

	this.instance_37 = new lib.ClipGroup_37();
	this.instance_37.setTransform(881,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_38 = new lib.ClipGroup_38();
	this.instance_38.setTransform(720.8,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_39 = new lib.ClipGroup_39();
	this.instance_39.setTransform(720.8,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_40 = new lib.ClipGroup_40();
	this.instance_40.setTransform(560.55,542.65,1,1,0,0,0,80,77.5);

	this.instance_41 = new lib.ClipGroup_41();
	this.instance_41.setTransform(560.55,542.65,1,1,0,0,0,80,77.5);

	this.instance_42 = new lib.ClipGroup_42();
	this.instance_42.setTransform(400.35,542.65,1,1,0,0,0,80,77.5);

	this.instance_43 = new lib.ClipGroup_43();
	this.instance_43.setTransform(400.45,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_44 = new lib.ClipGroup_44();
	this.instance_44.setTransform(240.25,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_45 = new lib.ClipGroup_45();
	this.instance_45.setTransform(240.25,542.65,1,1,0,0,0,80.1,77.5);

	this.instance_46 = new lib.ClipGroup_46();
	this.instance_46.setTransform(80,542.65,1,1,0,0,0,80,77.5);

	this.instance_47 = new lib.ClipGroup_47();
	this.instance_47.setTransform(80,542.65,1,1,0,0,0,80,77.5);

	this.instance_48 = new lib.ClipGroup_48();
	this.instance_48.setTransform(1201.35,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_49 = new lib.ClipGroup_49();
	this.instance_49.setTransform(1201.35,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_50 = new lib.ClipGroup_50();
	this.instance_50.setTransform(1041.1,387.6,1,1,0,0,0,80,77.5);

	this.instance_51 = new lib.ClipGroup_51();
	this.instance_51.setTransform(1041.1,387.6,1,1,0,0,0,80,77.5);

	this.instance_52 = new lib.ClipGroup_52();
	this.instance_52.setTransform(880.9,387.6,1,1,0,0,0,80,77.5);

	this.instance_53 = new lib.ClipGroup_53();
	this.instance_53.setTransform(881,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_54 = new lib.ClipGroup_54();
	this.instance_54.setTransform(720.8,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_55 = new lib.ClipGroup_55();
	this.instance_55.setTransform(720.8,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_56 = new lib.ClipGroup_56();
	this.instance_56.setTransform(560.55,387.6,1,1,0,0,0,80,77.5);

	this.instance_57 = new lib.ClipGroup_57();
	this.instance_57.setTransform(560.55,387.6,1,1,0,0,0,80,77.5);

	this.instance_58 = new lib.ClipGroup_58();
	this.instance_58.setTransform(400.35,387.6,1,1,0,0,0,80,77.5);

	this.instance_59 = new lib.ClipGroup_59();
	this.instance_59.setTransform(400.45,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_60 = new lib.ClipGroup_60();
	this.instance_60.setTransform(240.25,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_61 = new lib.ClipGroup_61();
	this.instance_61.setTransform(240.25,387.6,1,1,0,0,0,80.1,77.5);

	this.instance_62 = new lib.ClipGroup_62();
	this.instance_62.setTransform(80,387.6,1,1,0,0,0,80,77.5);

	this.instance_63 = new lib.ClipGroup_63();
	this.instance_63.setTransform(80,387.6,1,1,0,0,0,80,77.5);

	this.instance_64 = new lib.ClipGroup_64();
	this.instance_64.setTransform(1201.35,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_65 = new lib.ClipGroup_65();
	this.instance_65.setTransform(1201.35,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_66 = new lib.ClipGroup_66();
	this.instance_66.setTransform(1041.1,232.55,1,1,0,0,0,80,77.5);

	this.instance_67 = new lib.ClipGroup_67();
	this.instance_67.setTransform(1041.1,232.55,1,1,0,0,0,80,77.5);

	this.instance_68 = new lib.ClipGroup_68();
	this.instance_68.setTransform(880.9,232.55,1,1,0,0,0,80,77.5);

	this.instance_69 = new lib.ClipGroup_69();
	this.instance_69.setTransform(881,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_70 = new lib.ClipGroup_70();
	this.instance_70.setTransform(720.8,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_71 = new lib.ClipGroup_71();
	this.instance_71.setTransform(720.8,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_72 = new lib.ClipGroup_72();
	this.instance_72.setTransform(560.55,232.55,1,1,0,0,0,80,77.5);

	this.instance_73 = new lib.ClipGroup_73();
	this.instance_73.setTransform(560.55,232.55,1,1,0,0,0,80,77.5);

	this.instance_74 = new lib.ClipGroup_74();
	this.instance_74.setTransform(400.35,232.55,1,1,0,0,0,80,77.5);

	this.instance_75 = new lib.ClipGroup_75();
	this.instance_75.setTransform(400.45,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_76 = new lib.ClipGroup_76();
	this.instance_76.setTransform(240.25,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_77 = new lib.ClipGroup_77();
	this.instance_77.setTransform(240.25,232.55,1,1,0,0,0,80.1,77.5);

	this.instance_78 = new lib.ClipGroup_78();
	this.instance_78.setTransform(80,232.55,1,1,0,0,0,80,77.5);

	this.instance_79 = new lib.ClipGroup_79();
	this.instance_79.setTransform(80,232.55,1,1,0,0,0,80,77.5);

	this.instance_80 = new lib.ClipGroup_80();
	this.instance_80.setTransform(1201.35,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_81 = new lib.ClipGroup_81();
	this.instance_81.setTransform(1201.35,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_82 = new lib.ClipGroup_82();
	this.instance_82.setTransform(1041.1,77.5,1,1,0,0,0,80,77.5);

	this.instance_83 = new lib.ClipGroup_83();
	this.instance_83.setTransform(1041.1,77.5,1,1,0,0,0,80,77.5);

	this.instance_84 = new lib.ClipGroup_84();
	this.instance_84.setTransform(880.9,77.5,1,1,0,0,0,80,77.5);

	this.instance_85 = new lib.ClipGroup_85();
	this.instance_85.setTransform(881,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_86 = new lib.ClipGroup_86();
	this.instance_86.setTransform(720.8,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_87 = new lib.ClipGroup_87();
	this.instance_87.setTransform(720.8,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_88 = new lib.ClipGroup_88();
	this.instance_88.setTransform(560.55,77.5,1,1,0,0,0,80,77.5);

	this.instance_89 = new lib.ClipGroup_89();
	this.instance_89.setTransform(560.55,77.5,1,1,0,0,0,80,77.5);

	this.instance_90 = new lib.ClipGroup_90();
	this.instance_90.setTransform(400.35,77.5,1,1,0,0,0,80,77.5);

	this.instance_91 = new lib.ClipGroup_91();
	this.instance_91.setTransform(400.45,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_92 = new lib.ClipGroup_92();
	this.instance_92.setTransform(240.25,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_93 = new lib.ClipGroup_93();
	this.instance_93.setTransform(240.25,77.5,1,1,0,0,0,80.1,77.5);

	this.instance_94 = new lib.ClipGroup_94();
	this.instance_94.setTransform(80,77.5,1,1,0,0,0,80,77.5);

	this.instance_95 = new lib.ClipGroup_95();
	this.instance_95.setTransform(80,77.5,1,1,0,0,0,80,77.5);

	var maskedShapeInstanceList = [this.instance,this.instance_1,this.instance_2,this.instance_3,this.instance_4,this.instance_5,this.instance_6,this.instance_7,this.instance_8,this.instance_9,this.instance_10,this.instance_11,this.instance_12,this.instance_13,this.instance_14,this.instance_15,this.instance_16,this.instance_17,this.instance_18,this.instance_19,this.instance_20,this.instance_21,this.instance_22,this.instance_23,this.instance_24,this.instance_25,this.instance_26,this.instance_27,this.instance_28,this.instance_29,this.instance_30,this.instance_31,this.instance_32,this.instance_33,this.instance_34,this.instance_35,this.instance_36,this.instance_37,this.instance_38,this.instance_39,this.instance_40,this.instance_41,this.instance_42,this.instance_43,this.instance_44,this.instance_45,this.instance_46,this.instance_47,this.instance_48,this.instance_49,this.instance_50,this.instance_51,this.instance_52,this.instance_53,this.instance_54,this.instance_55,this.instance_56,this.instance_57,this.instance_58,this.instance_59,this.instance_60,this.instance_61,this.instance_62,this.instance_63,this.instance_64,this.instance_65,this.instance_66,this.instance_67,this.instance_68,this.instance_69,this.instance_70,this.instance_71,this.instance_72,this.instance_73,this.instance_74,this.instance_75,this.instance_76,this.instance_77,this.instance_78,this.instance_79,this.instance_80,this.instance_81,this.instance_82,this.instance_83,this.instance_84,this.instance_85,this.instance_86,this.instance_87,this.instance_88,this.instance_89,this.instance_90,this.instance_91,this.instance_92,this.instance_93,this.instance_94,this.instance_95];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_95},{t:this.instance_94},{t:this.instance_93},{t:this.instance_92},{t:this.instance_91},{t:this.instance_90},{t:this.instance_89},{t:this.instance_88},{t:this.instance_87},{t:this.instance_86},{t:this.instance_85},{t:this.instance_84},{t:this.instance_83},{t:this.instance_82},{t:this.instance_81},{t:this.instance_80},{t:this.instance_79},{t:this.instance_78},{t:this.instance_77},{t:this.instance_76},{t:this.instance_75},{t:this.instance_74},{t:this.instance_73},{t:this.instance_72},{t:this.instance_71},{t:this.instance_70},{t:this.instance_69},{t:this.instance_68},{t:this.instance_67},{t:this.instance_66},{t:this.instance_65},{t:this.instance_64},{t:this.instance_63},{t:this.instance_62},{t:this.instance_61},{t:this.instance_60},{t:this.instance_59},{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_3, new cjs.Rectangle(45.5,63.7,1190.5,841.9), null);


(lib.bg = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bg_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	mask.setTransform(960.025,540);

	// texture
	this.instance = new lib.ClipGroup_3();
	this.instance.setTransform(959.75,647.5,1.6128,1.6128,0,0,0,640.6,465.2);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// color
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E6E3DC").beginStroke().moveTo(-595.2,420.9).lineTo(-595.2,-420.9).lineTo(595.3,-420.9).lineTo(595.3,420.9).closePath();
	this.shape.setTransform(959.9974,678.835,1.6128,1.6128);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.bg, new cjs.Rectangle(0,0,1920.1,1080), null);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10,"frame11":11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E6E3DC").beginStroke().moveTo(-595.2,420.9).lineTo(-595.2,-420.9).lineTo(595.3,-420.9).lineTo(595.3,420.9).closePath();
	this.shape.setTransform(960.0116,540.0096,1.6128,1.2829);

	this.instance = new lib.bg();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape,p:{y:540.0096}}]},2).to({state:[{t:this.instance}]},1).to({state:[{t:this.shape,p:{y:540.0022}}]},1).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance}]},1).to({state:[{t:this.shape,p:{y:540.0022}}]},1).to({state:[{t:this.shape,p:{y:540.0022}}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3).to({_off:false},0).to({_off:true},1).wait(1).to({_off:false},0).wait(4).to({_off:true},1).wait(2));

	// size
	this.instance_1 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-73.4,-102.7,2066.7,1500.3);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1632.25,1039.05,0.728,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1496.1,1039.05,0.8475,0.4688,0,0,0,1,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1350.9,1039.05,0.8351,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(1160.6,1039.05,1.6428,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(940.45,1039.05,1.3084,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(749.9,1039.05,1.1976,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(558.85,1039.05,1.2835,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(398.75,1039.05,0.6008,0.4688,0,0,0,0.1,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(185.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(350,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(399.1,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1095.4,1009);
	this.instance.visible = false;

	this.instance_1 = new lib.pseudo();
	this.instance_1.setTransform(1730.1,1009,1.1053,1);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// title
	this.instance_2 = new lib.title();
	this.instance_2.setTransform(370,1015.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// logo
	this.occ_logo = new lib.logo();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(60,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_3 = new lib.background();
	this.instance_3.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_4 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-2,0,1924,1170), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, library_name);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// Model
	this.instance = new lib.zoom_brack();
	this.instance.setTransform(16.8,-40.9,1,1,0,0,0,0.3,0.3);

	this.instance_1 = new lib.zoom_white();
	this.instance_1.setTransform(102.35,-40.9,1,1,0,0,0,0.3,0.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[]},1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(958,480.6,964,689.4);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
 